export const TEST_HUB_URL = import.meta.env.VITE_URL_HUB_API;
export const TEST_CDK_URL = `${TEST_HUB_URL}cdk/`;
export const BASE_URL = import.meta.env.VITE_HUB_URL;
export const totalSyncStoreSteps = 2;
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
export const TOTAL_GETSTARTED_STEPS = 6;
export const COMPANY_SYNC_API = `${TEST_HUB_URL}sync`;
export const COMPANY_DELETE_API = import.meta.env.VITE_COMPANY_DELETE_ENDPOINT;
export const GRAPHQL_URI = import.meta.env.VITE_GRAPHQL_URL;
export const DB_NAME = import.meta.env.VITE_MONGO_TEST_DB_NAME;
export const RESYNC_API = `${TEST_HUB_URL}/v1/api/sync/customer`;
export const CDK_BASE_URL = `${TEST_HUB_URL}cdk/`;
export const SYNC_API = `${TEST_HUB_URL}/v1/api/sync`;
export const STRIPE_URL = `${TEST_HUB_URL}hub-stripe`;
export const VENDARA_URL = `${TEST_HUB_URL}hub-vendara`;
export const STRIPE_DASHBOARD_URL =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? 'https://dashboard.stripe.com'
    : 'https://dashboard.stripe.com/test';

export const COMPANIES_COLLECTION = 'companies';
export const ROLES_COLLECTION = 'roles';
export const PRODUCTS_COLLECTION = 'products';
export const VARIANTS_COLLECTION = 'variants';
export const CATEGORIES_COLLECTION = 'categories';
export const ATTRIBUTE_COLLECTION = 'attributes';
export const TAX_TABLE_COLLECTION = 'taxtables';
export const BUILDS_COLLECTION = 'builds';
export const USERS_COLLECTION = 'users';
export const ORDERS_COLLECTION = 'orders';
export const CUSTOMERS_COLLECTION = 'customers';
export const REFUNDS_COLLECTION = 'refunds';
export const STATION_COLLECTION = 'stations';
export const MANAGED_BUILDS_COLLECTION = 'managedBuilds';
export const STOCK_CHANGES_COLLECTION = 'stock-changes';
export const COMPANY_LOGO_MAX_SIZE = 512 * 1024;
export const PLACEHOLDER_IMAGE = '/placeholder.svg';
export const EMAIL_VALIDATION_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i;
export const STRING_VALIDATION_PATTERN = /^[A-Za-z ]+$/i;
export const NUMBER_VALIDATION_PATTERN = /^[0-9]+$/;
export const PHONE_VALIDATION_PATTERN = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const BASE_URL_VALIDATION_PATTERN = /^(https?:\/\/(www\.)?[\w.-]+\/)$/;
export const RATE_VALIDATION_PATTERN = /[0-9.,]/;
export const NUMBER_WITH_DECIMATES_VALIDATION_PATTERN = /^(\d+([.,]\d{1,2})?|[.,]\d{1,2})$/;
export const URL_VALIDATION_PATTERN =
  /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;

export const CURRENT_SUBSCRIPTIONS = [
  { label: 'basic', value: import.meta.env.VITE_OLIVER_BASIC_PLAN },
  { label: 'pro', value: import.meta.env.VITE_OLIVER_PRO_PLAN },
];

export const dateFormats = [
  { label: 'DD/MM/YYYY', value: 'EU', format: 'dd/MM/yyyy' },
  { label: 'MM/DD/YYYY', value: 'US', format: 'MM/dd/yyyy' },
];

export const STRIPE_TAX_TYPES = {
  AD: { ad_nrt: 'Andorra Tax Number' },
  AE: { ae_trn: 'United Arab Emirates Tax Registration Number' },
  AR: { ar_cuit: 'Argentina Unique Tax Identification Code' },
  AU: {
    au_abn: 'Australia Business Number',
    au_arn: 'Australia Australian Registered Number',
  },
  BG: { bg_uic: 'Bulgaria Unique Identification Code' },
  BO: { bo_tin: 'Bolivia Tax Identification Number' },
  BR: {
    br_cnpj: 'Brazil National Registry of Legal Entities',
    br_cpf: 'Brazil Individual Taxpayer Registry',
  },
  CA: {
    ca_bn: 'Canada Business Number',
    ca_gst_hst: 'Canada Goods and Services Tax / Harmonized Sales Tax',
    ca_pst_bc: 'Canada Provincial Sales Tax (British Columbia)',
    ca_pst_mb: 'Canada Provincial Sales Tax (Manitoba)',
    ca_pst_sk: 'Canada Provincial Sales Tax (Saskatchewan)',
    ca_qst: 'Canada Québec Sales Tax',
  },
  CH: { ch_vat: 'Switzerland Value Added Tax' },
  CL: { cl_tin: 'Chile Tax Identification Number' },
  CN: { cn_tin: 'China Tax Identification Number' },
  CO: { co_nit: 'Colombia Tax Identification Number' },
  CR: { cr_tin: 'Costa Rica Tax Identification Number' },
  DO: { do_rcn: 'Dominican Republic Tax Identification Number' },
  EC: { ec_ruc: 'Ecuadorian Tax ID (RUC)' },
  EG: { eg_tin: 'Egypt Tax Identification Number' },
  ES: { es_cif: 'Spain Tax Identification Code' },
  EU: {
    eu_vat: 'European Union Value Added Tax',
    eu_oss_vat: 'European Union One-Stop Shop VAT',
  },
  GB: { gb_vat: 'United Kingdom Value Added Tax' },
  GE: { ge_vat: 'Georgia Value Added Tax' },
  HK: { hk_br: 'Hong Kong Business Registration Number' },
  HU: { hu_tin: 'Hungary Tax Identification Number' },
  ID: { id_npwp: 'Indonesia Taxpayer Identification Number' },
  IL: { il_vat: 'Israel Value Added Tax' },
  IN: { in_gst: 'India Goods and Services Tax' },
  IS: { is_vat: 'Iceland Value Added Tax' },
  JP: {
    jp_cn: 'Japan Corporate Number',
    jp_rn: 'Japan Resident Number',
    jp_trn: 'Japan Taxpayer Identification Number',
  },
  KE: { ke_pin: 'Kenya Personal Identification Number' },
  KR: { kr_brn: 'South Korea Business Registration Number' },
  LI: { li_uid: 'Liechtenstein Unique Identification Number' },
  MX: { mx_rfc: 'Mexico Tax Identification Number' },
  MY: {
    my_frp: 'Malaysia Foreigner’s Registration Number',
    my_itn: 'Malaysia Income Tax Number',
    my_sst: 'Malaysia Sales and Service Tax Number',
  },
  NO: {
    no_vat: 'Norway Value Added Tax',
    no_voec: 'Norway VOEC (VAT on E-Commerce)',
  },
  NZ: { nz_gst: 'New Zealand Goods and Services Tax' },
  PE: { pe_ruc: 'Peru Unique Taxpayer Registry' },
  PH: { ph_tin: 'Philippines Tax Identification Number' },
  RO: { ro_tin: 'Romania Tax Identification Number' },
  RS: { rs_pib: 'Serbia Tax Identification Number' },
  RU: {
    ru_inn: 'Russia Taxpayer Identification Number',
    ru_kpp: 'Russia Tax Registration Reason Code',
  },
  SA: { sa_vat: 'Saudi Arabia Value Added Tax' },
  SG: {
    sg_gst: 'Singapore Goods and Services Tax',
    sg_uen: 'Singapore Unique Entity Number',
  },
  SI: { si_tin: 'Slovenia Tax Identification Number' },
  SV: { sv_nit: 'El Salvador National Identification Number' },
  TH: { th_vat: 'Thailand Value Added Tax' },
  TR: { tr_tin: 'Turkey Tax Identification Number' },
  TW: { tw_vat: 'Taiwan Value Added Tax' },
  UA: { ua_vat: 'Ukraine Value Added Tax' },
  US: { us_ein: 'United States Value Added Tax' },
};

export const STRIPE_PREMIUM_PLAN = {
  id: import.meta.env.VITE_FINAL_PREMIUM_PLAN_ID,
  price: import.meta.env.VITE_FINAL_PREMIUM_PRICE_ID,
};

export const STRIPE_OUTLETS_PLAN = {
  id: import.meta.env.VITE_FINAL_OUTLET_PLAN_ID,
  price: import.meta.env.VITE_FINAL_OUTLET_PRICE_ID,
};
export const STRIPE_STANDARD_PLAN = {
  id: import.meta.env.VITE_FINAL_STANDARD_PLAN_ID,
  price: import.meta.env.VITE_FINAL_STANDARD_PRICE_ID,
};

export const EUROPIAN_COUNTRIES = [
  'AL', // Albania
  'AD', // Andorra
  'AT', // Austria
  'BY', // Belarus
  'BE', // Belgium
  'BA', // Bosnia and Herzegovina
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IS', // Iceland
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LI', // Liechtenstein
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'MD', // Moldova
  'MC', // Monaco
  'ME', // Montenegro
  'MK', // North Macedonia
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'RU', // Russia
  'SM', // San Marino
  'RS', // Serbia
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'CH', // Switzerland
  'VA', // Vatican City
];

declare global {
  interface Window {
    dataLayer: any[];
    google: any;
  }
}

export const EXCLUDE_TAX_COUNTRIES = ['US', 'CA'];

export const ROOT_ORG_ID_DEV = '6697d0a167a2a968c9eeb61c';

export enum Features {
  OUTLETS = '9a924387-210a-4547-90af-ebc48cba339d',
  STATIONS = '0d3e6b16-d6a5-4952-85a9-fff2487cb5b5',
  USERS = 'f2643d80-542a-41d3-a590-b56f5bdc1399',
  BUILDER = '4f84e949-2c1b-48ee-b303-dfc4cc9eb6cc',
}

export enum FeatureGroupEnum {
  ACCOUNT_RESTRICTIONS = '54dbd025-eec6-4c47-8afc-d71747a5aded',
  MENU_RESTRICTIONS = 'fd14682e-a28f-4648-a386-804b84535c0c',
}

export const UNLIMITED_VALUE = 'Infinity';

export enum ROUTES {
  ALL = '/*',
  CDK = '/cdk',
  SETTINGS = 'settings',
  DASHBOARD = 'dashboard',
  ORGANIZATIONS = 'organizations',
  COMPANIES = 'companies',
  LIBRARY_THEMES = 'library/flows',
  LIBRARY_PRINT_BLOCKS = 'library/print-blocks',
  LIBRARY_PRESETS = 'library/presets',
  LIBRARY = 'library',
  FLOWS = 'flows',
  PRINT_BLOCKS = 'print-blocks',
  PRESETS = 'presets',
  TEMPLATES = 'templates',
  INTEGRATIONS = 'integrations',
  PLANS = 'plans',
  RESIDUALS = 'residuals',
}
